var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useContext, useCallback, useEffect } from 'react';
import { AptiveIcon, Button, Toast, } from '@aptive-env/storybook';
import { format, startOfToday } from 'date-fns';
import ParticipantExpandableList from 'components/ParticipantExpandableList';
import { EventDataWarningModal } from 'components/EventDataWarningModal';
import { CalendarEventTypeSelect } from 'components/CalendarEventTypeSelect';
import { EventTimePicker, EventLocationInput, EventDescriptionInput, EventTitleInput, EventGuestSelect, EventRepeatSelect, } from './EventModalComponents';
import { updateCalendarEvent, createCalendarEvent, overrideCalendarEvent, addCalendarEventParticipants, } from 'services/calendar';
import { CalendarStateContext } from 'context/CalendarContext';
import { convert24HourTo12Hour, convert12HourTo24Hour } from 'utils/convertHour';
import { isPastTime } from 'utils/calendar';
import { eventLabelConstants, eventValidationConstants, eventMessagesConstants, eventConstants, } from 'constants/index';
var EVENT_CREATED_SUCCESS = eventMessagesConstants.EVENT_CREATED_SUCCESS, EVENT_EDITED_SUCCESS = eventMessagesConstants.EVENT_EDITED_SUCCESS, EVENT_OVERRIDE_SUCCESS = eventMessagesConstants.EVENT_OVERRIDE_SUCCESS;
var EDIT_EVENT_LABEL = eventLabelConstants.EDIT_EVENT_LABEL, NEW_EVENT_LABEL = eventLabelConstants.NEW_EVENT_LABEL, SAVE_BUTTON_LABEL = eventLabelConstants.SAVE_BUTTON_LABEL, ADD_EVENT_BUTTON_LABEL = eventLabelConstants.ADD_EVENT_BUTTON_LABEL, CANCEL_BUTTON_LABEL = eventLabelConstants.CANCEL_BUTTON_LABEL;
var EVENT_TITLE_MAX_LENGTH = eventValidationConstants.EVENT_TITLE_MAX_LENGTH, EVENT_DESCRIPTION_MAX_LENGTH = eventValidationConstants.EVENT_DESCRIPTION_MAX_LENGTH, EVENT_TITLE_MISSING_WARNING_CONTENT = eventValidationConstants.EVENT_TITLE_MISSING_WARNING_CONTENT, EVENT_TITLE_MISSING_WARNING_TITLE = eventValidationConstants.EVENT_TITLE_MISSING_WARNING_TITLE, EVENT_PAST_DATE_WARNING_TITLE = eventValidationConstants.EVENT_PAST_DATE_WARNING_TITLE, EVENT_PAST_DATE_WARNING_CONTENT = eventValidationConstants.EVENT_PAST_DATE_WARNING_CONTENT;
var EVENT_EDIT_TYPE = eventConstants.EVENT_EDIT_TYPE, EVENT_NEW_TYPE = eventConstants.EVENT_NEW_TYPE, EVENT_OVERRIDE_TYPE = eventConstants.EVENT_OVERRIDE_TYPE, EVENT_INITIAL_TITLE = eventConstants.EVENT_INITIAL_TITLE, EVENT_INITIAL_START_TIME = eventConstants.EVENT_INITIAL_START_TIME, EVENT_INITIAL_END_TIME = eventConstants.EVENT_INITIAL_END_TIME;
var emptyLocationData = {
    address: '',
    city: '',
    state: '',
    zip: '',
};
var emptyGeoLocation = {
    lat: 0,
    lng: 0,
};
export var EventUpdateModal = function (_a) {
    var _b, _c, _d, _e;
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, updateType = _a.updateType, event = _a.event, onUpdate = _a.onUpdate, eventParticipants = _a.eventParticipants, eventDate = _a.eventDate, onSuccess = _a.onSuccess, onClose = _a.onClose;
    var _f = useContext(CalendarStateContext), eventTypes = _f.eventTypes, selectedOffice = _f.selectedOffice;
    var _g = useState({
        title: '',
        description: '',
        selectedDate: startOfToday(),
        selectedStartTime: EVENT_INITIAL_START_TIME,
        selectedEndTime: EVENT_INITIAL_END_TIME,
        eventType: eventTypes[0],
        participants: [],
        locationData: emptyLocationData,
        geoLocation: emptyGeoLocation,
        interval: 'once',
        endAfter: 'never',
    }), eventData = _g[0], setEventData = _g[1];
    var _h = useState(false), updateEvent = _h[0], setUpdateEvent = _h[1];
    var _j = useState(false), isSaving = _j[0], setIsSaving = _j[1];
    var _k = useState({}), errors = _k[0], setErrors = _k[1];
    var _l = useState(false), isEventDataWarning = _l[0], setIsEventDataWarning = _l[1];
    var _m = useState({
        title: '',
        content: '',
    }), eventWarningData = _m[0], setEventWarningData = _m[1];
    var initAddress = event
        ? ((_b = event.address) === null || _b === void 0 ? void 0 : _b.address)
            ? event.address.address
            : [(_c = event.address) === null || _c === void 0 ? void 0 : _c.city, (_d = event.address) === null || _d === void 0 ? void 0 : _d.state, (_e = event.address) === null || _e === void 0 ? void 0 : _e.zip]
                .filter(Boolean)
                .join(', ')
        : '';
    var parseEventType = useCallback(function (eventType) {
        var _a;
        return (_a = eventTypes.find(function (type) { return type.id === eventType; })) !== null && _a !== void 0 ? _a : eventTypes[0];
    }, [eventTypes]);
    useEffect(function () {
        if (event) {
            setEventData(function (prevData) { return (__assign(__assign({}, prevData), { title: event.title, description: event.description, selectedStartTime: convert24HourTo12Hour(event.start_at), selectedEndTime: convert24HourTo12Hour(event.end_at), locationData: event.address || emptyLocationData, geoLocation: event.location || emptyGeoLocation, eventType: parseEventType(event.event_type), interval: event.interval, repeatEvery: event.repeat_every, weekDays: event.week_days, weekNum: event.week_num, occurrences: event.occurrences })); });
        }
        if (eventDate) {
            setEventData(function (prevData) { return (__assign(__assign({}, prevData), { selectedDate: eventDate })); });
        }
        if (eventParticipants) {
            setEventData(function (prevData) { return (__assign(__assign({}, prevData), { participants: eventParticipants })); });
        }
    }, [setEventData, event, eventDate, eventParticipants, eventTypes, parseEventType]);
    var handleUpdate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updateData, params, eventAction, response, eventId, eventParticipants_1, addParticipantsResponse, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsSaving(true);
                    updateData = {
                        title: eventData.title,
                        description: eventData.description,
                        location_lat: eventData.geoLocation.lat,
                        location_lng: eventData.geoLocation.lng,
                        address: eventData.locationData.address,
                        city: eventData.locationData.city,
                        state: eventData.locationData.state,
                        zip: eventData.locationData.zip,
                    };
                    params = {};
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 8, , 9]);
                    if (updateType === EVENT_NEW_TYPE) {
                        params = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, updateData), { office_id: selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.id, event_type: (_a = eventData.eventType) === null || _a === void 0 ? void 0 : _a.id, start_date: format(eventData.selectedDate, 'yyyy-MM-dd') }), (eventData.endDate && { end_date: eventData.endDate })), { start_at: convert12HourTo24Hour(eventData.selectedStartTime), end_at: convert12HourTo24Hour(eventData.selectedEndTime), interval: eventData.interval, end_after: eventData.endAfter }), (eventData.weekDays && { week_days: eventData.weekDays })), (eventData.weekNum && { week_num: eventData.weekNum })), (eventData.occurrences && { occurrences: eventData.occurrences })), (eventData.repeatEvery && { repeat_every: eventData.repeatEvery }));
                    }
                    if (updateType === EVENT_EDIT_TYPE) {
                        params = __assign(__assign({}, updateData), { eventId: event.id });
                        if (onUpdate) {
                            onUpdate();
                        }
                    }
                    if (updateType === EVENT_OVERRIDE_TYPE) {
                        params = __assign(__assign({}, updateData), { eventId: event.id, date: eventDate ? format(eventDate, 'yyyy-MM-dd') : event.date, start_time: convert12HourTo24Hour(eventData.selectedStartTime), end_time: convert12HourTo24Hour(eventData.selectedEndTime), is_canceled: false, meeting_link: event.meeting_link });
                        if (onUpdate) {
                            onUpdate();
                        }
                    }
                    eventAction = updateType === EVENT_NEW_TYPE
                        ? createCalendarEvent
                        : updateType === EVENT_EDIT_TYPE
                            ? updateCalendarEvent
                            : overrideCalendarEvent;
                    return [4 /*yield*/, eventAction(params)];
                case 2:
                    response = _c.sent();
                    if (!response._metadata.success) return [3 /*break*/, 6];
                    eventId = updateType === EVENT_OVERRIDE_TYPE ? event.id : response.result.id;
                    eventParticipants_1 = (_b = eventData.participants) === null || _b === void 0 ? void 0 : _b.map(function (guest) { return guest.id; });
                    if (!(eventId && eventParticipants_1.length > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, addCalendarEventParticipants(eventId, eventParticipants_1)];
                case 3:
                    addParticipantsResponse = _c.sent();
                    if (addParticipantsResponse._metadata.success) {
                        onSuccess(updateType === EVENT_NEW_TYPE ? EVENT_CREATED_SUCCESS : updateType === EVENT_EDIT_TYPE ? EVENT_EDITED_SUCCESS : EVENT_OVERRIDE_SUCCESS);
                    }
                    else if (response.result.errors) {
                        setErrors(response.result.errors);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    onSuccess(updateType === EVENT_NEW_TYPE ? EVENT_CREATED_SUCCESS : updateType === EVENT_EDIT_TYPE ? EVENT_EDITED_SUCCESS : EVENT_OVERRIDE_SUCCESS);
                    _c.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    if (response.result.errors) {
                        setErrors(response.result.errors);
                    }
                    _c.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    e_1 = _c.sent();
                    console.log(e_1);
                    return [3 /*break*/, 9];
                case 9:
                    setIsSaving(false);
                    setUpdateEvent(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (updateEvent)
            handleUpdate();
        // eslint-disable-next-line
    }, [updateEvent]);
    var isDataInvalid = function () {
        var trimmedTitle = eventData.title.trim();
        var trimmedDescription = eventData.description.trim();
        setEventData(function (prevData) { return (__assign(__assign({}, prevData), { title: trimmedTitle, description: trimmedDescription })); });
        var titleErrors = [];
        var descriptionErrors = [];
        if (trimmedTitle && trimmedTitle.length > 100) {
            titleErrors.push(EVENT_TITLE_MAX_LENGTH);
        }
        if (trimmedDescription && trimmedDescription.length > 500) {
            descriptionErrors.push(EVENT_DESCRIPTION_MAX_LENGTH);
        }
        setErrors({
            title: titleErrors,
            description: descriptionErrors,
        });
        return titleErrors.length || descriptionErrors.length;
    };
    var handleClose = function () {
        if (onClose)
            onClose();
        setIsOpen(false);
    };
    var handleOnClickSave = function (warning) {
        var _a;
        if (isDataInvalid())
            return;
        var currentTitle = eventData.title;
        var allowPastDate = false;
        if (warning === EVENT_TITLE_MISSING_WARNING_TITLE) {
            setEventData(function (prevData) { return (__assign(__assign({}, prevData), { title: EVENT_INITIAL_TITLE })); });
            currentTitle = EVENT_INITIAL_TITLE;
        }
        if (warning === EVENT_PAST_DATE_WARNING_TITLE)
            allowPastDate = true;
        setIsEventDataWarning(false);
        setEventWarningData({ title: '', content: '' });
        if (currentTitle.length === 0) {
            setEventWarningData({
                title: EVENT_TITLE_MISSING_WARNING_TITLE,
                content: EVENT_TITLE_MISSING_WARNING_CONTENT,
            });
            setIsEventDataWarning(true);
        }
        else if (isPastTime(eventData.selectedDate, eventData.selectedStartTime, ((_a = selectedOffice === null || selectedOffice === void 0 ? void 0 : selectedOffice.timezone) === null || _a === void 0 ? void 0 : _a.timezone) || '') &&
            !allowPastDate) {
            setEventWarningData({
                title: EVENT_PAST_DATE_WARNING_TITLE,
                content: EVENT_PAST_DATE_WARNING_CONTENT,
            });
            setIsEventDataWarning(true);
        }
        else {
            setUpdateEvent(true);
        }
    };
    var handleSelectEventType = function (selected) {
        setEventData(function (prevData) { return (__assign(__assign({}, prevData), { eventType: selected })); });
    };
    return (_jsx(_Fragment, { children: isOpen && (_jsxs("div", __assign({ className: "sidebar fixed top-0 left-0 h-full w-full z-[50]" }, { children: [_jsx("div", { className: "bg-[#0000001A] absolute top-0 left-0 h-full w-full", onClick: handleClose }), _jsxs("div", __assign({ className: "flex flex-col justify-between absolute right-0 bg-white h-full w-[384px] p-4 border overflow-x-hidden transition-all duration-500" }, { children: [_jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsxs("div", __assign({ className: "flex justify-between items-center h-5" }, { children: [_jsx("div", __assign({ className: "font-inter text-[16px] font-semibold leading-5 text-dark-gray-100" }, { children: event ? EDIT_EVENT_LABEL : NEW_EVENT_LABEL })), _jsx(AptiveIcon, { icon: "x", className: "w-[20px] h-[20px] stroke-[#3D3D3D] fill-none cursor-pointer", onClick: handleClose })] })), _jsxs("div", __assign({ className: "mt-5 flex flex-col gap-6" }, { children: [_jsx(EventTitleInput, { eventData: eventData, setEventData: setEventData, errors: errors, setErrors: setErrors }), _jsx(CalendarEventTypeSelect, { items: eventTypes, selected: eventData.eventType, onSelect: handleSelectEventType, disabled: updateType === EVENT_EDIT_TYPE || updateType === EVENT_OVERRIDE_TYPE }), _jsx(EventTimePicker, { eventData: eventData, setEventData: setEventData, disabled: updateType === EVENT_EDIT_TYPE }), _jsx(EventRepeatSelect, { eventData: eventData, setEventData: setEventData, isOpen: isOpen, disabled: updateType === EVENT_EDIT_TYPE || updateType === EVENT_OVERRIDE_TYPE, event: event }), _jsx(EventGuestSelect, { eventData: eventData, setEventData: setEventData }), eventData.participants.length > 0 && (_jsx(ParticipantExpandableList, { participants: eventData.participants })), _jsx(EventLocationInput, { initAddress: initAddress, setEventData: setEventData, setErrors: setErrors }), _jsx(EventDescriptionInput, { eventData: eventData, setEventData: setEventData, errors: errors, setErrors: setErrors })] }))] })), _jsx("div", __assign({ className: "bottom-5 mt-10" }, { children: _jsxs("div", __assign({ className: "flex justify-end" }, { children: [_jsx(Button, __assign({ variant: "neutral", onClick: handleClose, className: "w-[168px] h-9 text-[#4B5563]" }, { children: CANCEL_BUTTON_LABEL })), _jsx(Button, __assign({ className: "text-white bg-[#007AFF] ml-[10px] w-[168px] h-9 text-14 font-medium", variant: "custom", disabled: isSaving, onClick: function () { return handleOnClickSave(); } }, { children: event ? SAVE_BUTTON_LABEL : ADD_EVENT_BUTTON_LABEL }))] })) }))] })), _jsx(EventDataWarningModal, { open: isEventDataWarning, data: eventWarningData, onClickGoBack: function () { return setIsEventDataWarning(false); }, onClickSave: handleOnClickSave }), errors.address && (_jsx("div", __assign({ className: "fixed top-10 right-10" }, { children: _jsx(Toast, __assign({ dismissible: true, isIcon: true, onDismiss: function () { return setErrors(function (prevErrors) { return (__assign(__assign({}, prevErrors), { address: '' })); }); }, status: "warning" }, { children: errors.address })) })))] }))) }));
};
